query findEvent(
  $id: UUID!
) {
  event: eventByEventId(eventId: $id) {
    appliedTemplates: eventAppliedTemplatesByEventId {
      nodes {
        sportTemplate: appliedSportTemplate {
          sportTemplateId
          name
        }
      }
    }
  }
}